import React, { useState, useEffect } from "react";
import { ReactComponent as InfoIcon } from "../../../../../../assets/fi-rr-info.svg";
import CustomDate from "../../../../../../components/customDate/CustomDate";
import CustomSelect from "../../../../../../components/customSelect/CustomSelect";
import CustomFile from "../../../../../../components/customFile/CustomFile";
import CustomInput from "../../../../../../components/customInput/CustomInput";
import CustomButton from "../../../../../../components/CustomButton";
import { Group, Modal, Radio, Tooltip } from "@mantine/core";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { Col, Row, Button } from "reactstrap";
import { Controller } from "react-hook-form";
import AgreementModal from "../../../../../fileClaim/AgreementModal";
import DocuSignModal from "../../../../../fileClaim/DocuSignModal";
import PowerContent from "../../../../../fileClaim/PowerContent";
import { ReactComponent as FlyClaimIcon } from "../../../../../../assets/header button.svg";
import { ReactComponent as Avatar } from "../../../../../../assets/Avatar.svg";
import { ReactComponent as DocumentIcon } from "../../../../../../assets/Document.svg";
import ViewFileModal from "../../../../../../components/Modals/ViewFileModal.js";
import attachmenturl from "../../../../../../api/attachmenturl";
import Swal from "sweetalert2";
import base_url from "../../../../../../api/bootapi.js";
import axios from "axios";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { ReactComponent as Close } from "../../../../../../assets/modalCloseIcon.svg";


const Attorneynotes = ({
  onSubmit,
  setStepsix,
  isTermsChecked,
  handleTermsChange,
  handleTermsLinkClick,
  isAgreementChecked,
  handleCheckAgreement,
  handleAgreementChange,
  openAgreementModal,
  openPowerOfAttorneyModal,
  handlePowerOfAttorneyChange,
  handleCheckPowerOfAttorney,
  signatureCaptured,
  isPowerOfAttorneyChecked,
  familyMembers,
  pdfBlob,
  poaPdf,
  isAgreementModalOpen,
  closeAgreementModal,
  handleSignatureAdded,
  handlePdfGenerated,
  setEnvelopeId,
  setAgreementUrl,
  envolpeId,
  setIsDocusignModalOpen,
  signUrl,
  setSignUrl,
  setIsFetching,
  setDocumentFetched,
  activeTab,
  dataToStore,
  isDocuSignModalOpen,
  handleIframeClose,
  powerRef,
  previousNote,
  isPowerOfAttorneyFetchedErrorModal,
  signers,
  setSigner,
  setPowerPdf,
  setPoaPdf,
  draftNote,
  setDraftNote
}) => {
  const options = ["hii", "hello"];
  const [value, setValue] = useState("");
  const [checkboxes, setCheckboxes] = useState({
    terms: false,
    agreement: false,
    powerOfAttorney: false,
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      note: draftNote ?? '', // Initialize with empty string
    },
  });

  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [imageModalTitle, setImageModalTitle] = useState("");
  const [imageModalFileUrl, setImageModalFileUrl] = useState("");

  const [showAll, setShowAll] = useState(false);
  const notesToShow = previousNote
    ? showAll
      ? previousNote
      : previousNote.slice(0, 4)
    : [];

  // Enable/disable next button based on checkbox states
  useEffect(() => {
    const allChecked =
      isTermsChecked &&
      isAgreementChecked &&
      (familyMembers.length > 0 ? isPowerOfAttorneyChecked : true);
    setStepsix(allChecked);
    console.log("67----->", allChecked);
  }, [
    isAgreementChecked,
    isTermsChecked,
    setStepsix,
    isPowerOfAttorneyChecked,
  ]);

  const handleFormSubmit = (data) => {
    onSubmit(data);
  };

  const isImageFile = (url) => {
    return /\.(jpeg|jpg|png|gif)$/i.test(url);
  };

  const openImageViewModal = (title, fileUrl) => {
    setImageModalTitle(title);
    setImageModalFileUrl(fileUrl);
    setImageModalOpen(true);
  };
  const closeImageModal = () => {
    setImageModalOpen(false);
  };

  const handleViewFile = (url) => {
    if (!url) {
      return;
    }

    const fileUrl = attachmenturl + url;
    if (!isImageFile(fileUrl)) {
      window.open(fileUrl, "_blank");
    } else {
      openImageViewModal("View File", fileUrl);
    }
  };


  const getSignerName = (signer) => {
    let name = "";

    if (signer) {
      if (typeof signer !== "string") return "";
      name = signer.charAt(0).toUpperCase() + signer.slice(1).toLowerCase();
      if (name.length > 22) {
        name = name.slice(0, 22) + "...";
      }

      return name;
    } else {
      return "";
    }
  };


  const handleLoad = () => {
    setbackdropopen(false);
  };


  const handleCopyLink = (signer) => {
    const link = signer.signing_url;
    navigator.clipboard
      .writeText(link)
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Link Copied",
          text: `The signing link has been copied to your clipboard.`,
        });
      })
      .catch((error) => {
        console.error("Failed to copy link:", error);
        Swal.fire({
          icon: "error",
          title: "Copy Failed",
          text: `Failed to copy the signing link.`,
        });
      });
  };

  const [signerDetails, setSignerDetails] = useState([]);
  const [openSignerModal, setOpenSignerModal] = useState(false)



  const [wesignUrl, setWesignUrl] = useState(null);
  const [recipientEmail, setRecipientEmail] = useState(null);
  const [signEnvolpeId, setSignEnvolpeId] = useState(null);
  const [isWesignModalOpen, setIsWesignModalOpen] = useState(false);
  const [backdropopen, setbackdropopen] = useState(false);


  useEffect(() => {
    const onBack = () => {
      if (isWesignModalOpen) {
        setIsWesignModalOpen(false); // Close modal
      }
    };

    window.addEventListener("popstate", onBack);
    return () => window.removeEventListener("popstate", onBack);
  }, [isWesignModalOpen]);

  const handleSignerClick = (signer) => {
    console.log("Clicked Signer:", signer);
    setShowContinueBtn(false)
    setWesignUrl(signer.signing_url);
    setRecipientEmail(signer.recipient);
    setSignEnvolpeId(signer.envelope_id);
    setIsWesignModalOpen(true);
    setbackdropopen(true);
    window.history.pushState({ modal: true }, "");
  };



  const handleClose = async () => {
    setOpenSignerModal(false)
    setIsWesignModalOpen(false);

    try {
      setbackdropopen(true);

      const [genPdfBlob] = await Promise.all([
        fetchSignedDocument(signEnvolpeId),

      ]);


      if (genPdfBlob) {
        const poaFile = new File([genPdfBlob], "power_of_attorney_dd.pdf", {
          type: genPdfBlob.type,
        });


        setPoaPdf(poaFile);
        setPowerPdf(poaFile)


      }

      // setSignatureCaptured(true);
      // setDocumentFetched(true);
      // console.log("Signer status response:", signerStatus);
    } catch (error) {
      console.error("Error during parallel execution:", error);
    } finally {
      setbackdropopen(false);
    }

    window.history.back();
  };


  const fetchSignedDocument = async (envolpeId, envelopeRecipientEmail = recipientEmail) => {
    const sign_url = `${base_url.api1}/tourapp/wesign_signed_doc_new?id=${envolpeId}&email=${envelopeRecipientEmail}`;
    const response = await axios.get(sign_url);

    if (response?.data && response?.data?.status_code === 200) {
      const updated = signers.map(item => {
        if (item.recipient === envelopeRecipientEmail) {
          return {
            ...item,
            signed: true,

          };
        }
        return item;
      });

      setSigner(updated)
    }
    if (response.data?.Document) {
      const document_url = response.data.Document;
      const pdfResponse = await fetch(document_url);
      if (!pdfResponse.ok) throw new Error("Failed to fetch the document.");
      const genPdfBlob = await pdfResponse.blob();
      return genPdfBlob;
    } else {
      throw new Error("Signed document not found.");
    }
  };
  const [showContinueBtn, setShowContinueBtn] = useState(false)


  useEffect(() => {
    const onMessage = (event) => {
      if (event.data?.type === "IFRAME_URL_CHANGED") {
        console.log("Iframe URL changed to:", event.data.url);
        // Do whatever you need here
        if (event.data.url.includes("postsigning")) {

          setShowContinueBtn(true)
        }
      }
    };

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);





  return (
    <div className="stepper-container">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropopen}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {dataToStore && (
        <PowerContent ref={powerRef} agreementDetails={dataToStore} />
      )}

      <div className="stepper-header-container">
        <h3 className="stepper-header" style={{ margin: 0 }}>
          Attorney notes & submission
        </h3>
      </div>
      {previousNote && previousNote.length > 0 && (
        <div>
          <div className="stepper-header-container">
            <h3 className="stepper-sub-header w-100">
              Previous Notes ({previousNote?.length ?? 0})
            </h3>
            {previousNote.length > 4 && (
              <CustomButton
                btnText={showAll ? "Show Less" : "Show More"}
                color="primary"
                onClick={() => setShowAll((prev) => !prev)}
                className="mt-3 mb-3"
                style={{
                  padding: "6px 16px",
                  maxWidth: "fit-content",
                  whiteSpace: "nowrap",
                }}
                type="secondary"
              />
            )}
          </div>
          <div
            className="mobile-dashboard-comments"
            style={{ margin: "-10px 0 0" }}
          >
            {notesToShow &&
              notesToShow.map((note, index) => (
                <div
                  className="comment-box-wrapper"
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#EFF3F9" : "#fff",
                    padding: "10px 12px",
                  }}
                >
                  <div className="comment-box-header-wrapper">
                    <div className="comment-name-wrapper">
                      {note.user === "customer" ? <Avatar /> : <FlyClaimIcon />}

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <span className="name">
                          {note.user.charAt(0).toUpperCase() +
                            note.user.slice(1)}
                        </span>
                        <span className="designation">{note.timestamp}</span>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{ margin: "6px 8px" }}
                    className="comment-text-box"
                  >
                    <p style={{ margin: "0px" }}>{note.note}</p>
                  </div>
                  {note?.files && note?.files.length > 0 && (
                    <div className="edit-claim-note-files-container">
                      {note?.files?.map((fileUrl, index) => {
                        if (!fileUrl) return null;
                        const fileName = fileUrl?.split("/").pop();
                        const shortenedName =
                          fileName.length > 20
                            ? `${fileName.slice(0, 20)}...`
                            : fileName;
                        return (
                          <div
                            onClick={() => handleViewFile(fileUrl)}
                            key={index}
                            className="edit-claim-note-files"
                          >
                            <DocumentIcon style={{ marginRight: 8 }} />
                            {shortenedName}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              ))}
          </div>
        </div>
      )}

      <div>
        <h4 className="stepper-sub-header" style={{ margin: "20px 0 5px" }}>
          Explain your claim in detail (for attorneys) (optional)
        </h4>
      </div>





      <Modal
        opened={openSignerModal}
        onClose={() => setOpenSignerModal(false)}
        size={window.innerWidth < 768 ? "100%" : "40%"}
        fullScreen={window.innerWidth < 768} title='Signer Details'>
        {/* <h1 style={{fontSize:"24px",padding:"10px",marginBottom:"40px"}}>Signer Details</h1> */}
        <div style={{ display: "flex", flexDirection: "column", gap: "10px", minHeight: "50vh" }}>
          {signers &&
            signers.length > 0 &&
            signers.map((signer, index) => (
              <div className="signer-box" key={index} style={{ width: "100%" }}>
                <div className="signer-details">
                  <span className="signer-icon">
                    {signer?.name.slice(0, 1).toUpperCase()}
                  </span>
                  <span className="signer-name">
                    {getSignerName(signer?.name)}
                  </span>
                </div>

                <div className="signer-status">
                  {signer?.signed ? (
                    <span className="signed-success">Signed</span>
                  ) : (
                    <>
                      <Tooltip label='Check Status'>

                        <span
                          className="sign-btn"
                        //  onClick={() => handleCheckStatus(signer)}
                        >
                          <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M3.67981 11.3333H2.92981H3.67981ZM3.67981 13L3.15157 13.5324C3.44398 13.8225 3.91565 13.8225 4.20805 13.5324L3.67981 13ZM5.88787 11.8657C6.18191 11.574 6.18377 11.0991 5.89203 10.8051C5.60029 10.511 5.12542 10.5092 4.83138 10.8009L5.88787 11.8657ZM2.52824 10.8009C2.2342 10.5092 1.75933 10.511 1.46759 10.8051C1.17585 11.0991 1.17772 11.574 1.47176 11.8657L2.52824 10.8009ZM18.6156 7.39279C18.8325 7.74565 19.2944 7.85585 19.6473 7.63892C20.0001 7.42199 20.1103 6.96007 19.8934 6.60721L18.6156 7.39279ZM12.0789 2.25C7.03155 2.25 2.92981 6.3112 2.92981 11.3333H4.42981C4.42981 7.15072 7.84884 3.75 12.0789 3.75V2.25ZM2.92981 11.3333L2.92981 13H4.42981L4.42981 11.3333H2.92981ZM4.20805 13.5324L5.88787 11.8657L4.83138 10.8009L3.15157 12.4676L4.20805 13.5324ZM4.20805 12.4676L2.52824 10.8009L1.47176 11.8657L3.15157 13.5324L4.20805 12.4676ZM19.8934 6.60721C18.287 3.99427 15.3873 2.25 12.0789 2.25V3.75C14.8484 3.75 17.2727 5.20845 18.6156 7.39279L19.8934 6.60721Z" fill="#222222"></path> <path d="M20.3139 11L20.8411 10.4666C20.549 10.1778 20.0788 10.1778 19.7867 10.4666L20.3139 11ZM18.1004 12.1333C17.8058 12.4244 17.8031 12.8993 18.0942 13.1939C18.3854 13.4885 18.8603 13.4913 19.1549 13.2001L18.1004 12.1333ZM21.4729 13.2001C21.7675 13.4913 22.2424 13.4885 22.5335 13.1939C22.8247 12.8993 22.822 12.4244 22.5274 12.1332L21.4729 13.2001ZM5.31794 16.6061C5.1004 16.2536 4.6383 16.1442 4.28581 16.3618C3.93331 16.5793 3.82391 17.0414 4.04144 17.3939L5.31794 16.6061ZM11.8827 21.75C16.9451 21.75 21.0639 17.6915 21.0639 12.6667H19.5639C19.5639 16.8466 16.1332 20.25 11.8827 20.25V21.75ZM21.0639 12.6667V11H19.5639V12.6667H21.0639ZM19.7867 10.4666L18.1004 12.1333L19.1549 13.2001L20.8411 11.5334L19.7867 10.4666ZM19.7867 11.5334L21.4729 13.2001L22.5274 12.1332L20.8411 10.4666L19.7867 11.5334ZM4.04144 17.3939C5.65405 20.007 8.56403 21.75 11.8827 21.75V20.25C9.10023 20.25 6.66584 18.7903 5.31794 16.6061L4.04144 17.3939Z" fill="#222222"></path> </g></svg>
                        </span>
                      </Tooltip>
                      <Tooltip label='Copy Link'>

                        <span
                          className="sign-btn"
                          onClick={() => handleCopyLink(signer)}
                        >
                          <svg
                            width="20px"
                            height="20px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              id="SVGRepo_bgCarrier"
                              stroke-width="0"
                            ></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <path
                                d="M3 16V4C3 2.89543 3.89543 2 5 2H15M9 22H18C19.1046 22 20 21.1046 20 20V8C20 6.89543 19.1046 6 18 6H9C7.89543 6 7 6.89543 7 8V20C7 21.1046 7.89543 22 9 22Z"
                                stroke="#314064"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>{" "}
                            </g>
                          </svg>
                        </span>
                      </Tooltip>
                      <Tooltip label='Sign'>


                        <span
                          className="sign-btn"
                          onClick={() => handleSignerClick(signer)}
                        >
                          <svg
                            fill="#314064"
                            width="20px"
                            height="20px"
                            viewBox="0 0 56 56"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              id="SVGRepo_bgCarrier"
                              stroke-width="0"
                            ></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              <path d="M 1.1883 43.4869 L 13.6935 43.4869 C 13.4483 44.4300 13.3162 45.3542 13.3162 46.2030 C 13.3162 49.2397 15.0138 51.4088 18.5786 51.4088 C 22.9168 51.4088 26.4250 48.3532 28.6884 43.4869 L 54.8118 43.4869 C 55.4719 43.4869 56 42.9777 56 42.3175 C 56 41.6574 55.4719 41.1670 54.8118 41.1670 L 29.6315 41.1670 C 30.6877 38.0737 31.3290 34.4523 31.4611 30.5290 C 32.6494 30.2650 33.8941 30.1329 35.1769 30.1329 C 35.8371 30.1329 36.2141 30.4159 36.2141 30.9063 C 36.2141 32.5472 35.3276 33.8298 35.3276 35.4708 C 35.3276 36.9043 36.3841 37.7719 37.7608 37.7719 C 41.5896 37.7719 46.2108 31.2269 47.7385 31.2269 C 49.1342 31.2269 47.3990 37.1117 52.1522 37.1117 C 52.9256 37.1117 53.9253 36.9043 54.6986 36.4139 C 55.1513 36.0932 55.4719 35.6405 55.4719 35.0558 C 55.4719 34.3391 55.0192 33.7544 54.2648 33.7544 C 53.6046 33.7544 53.0577 34.3013 52.4164 34.3013 C 50.3792 34.3013 52.3218 28.0393 48.5687 28.0393 C 45.2868 28.0393 40.1561 34.4145 38.8548 34.4145 C 38.6852 34.4145 38.5531 34.3202 38.5531 34.0939 C 38.5531 33.4149 39.4017 31.8871 39.4017 30.3593 C 39.4017 28.4732 37.8361 27.2660 35.3844 27.2660 C 34.0451 27.2660 32.7248 27.3980 31.4611 27.6432 C 31.0461 17.7032 26.3307 9.8756 19.1256 9.8756 C 14.2782 9.8756 10.5436 14.0063 10.5436 19.2687 C 10.5436 25.4176 14.5423 30.6799 19.5217 34.1693 C 17.3149 36.3384 15.5985 38.8093 14.5423 41.1670 L 1.1883 41.1670 C .5281 41.1670 0 41.6574 0 42.3175 C 0 42.9777 .5281 43.4869 1.1883 43.4869 Z M 13.4106 19.2687 C 13.4106 15.5907 15.9003 12.7426 19.1256 12.7426 C 24.7841 12.7426 28.4432 19.7780 28.6130 28.4166 C 26.0101 29.3219 23.6335 30.6988 21.5776 32.3397 C 17.6544 29.6237 13.4106 25.1347 13.4106 19.2687 Z M .6413 37.1495 C 1.1317 37.6399 1.8673 37.6210 2.3765 37.1495 L 4.7342 34.7918 L 7.0919 37.1495 C 7.5823 37.6399 8.3368 37.6399 8.8272 37.1495 C 9.3176 36.6591 9.3176 35.9046 8.8272 35.4142 L 6.4695 33.0754 L 8.8272 30.7177 C 9.3176 30.2273 9.3176 29.4917 8.8272 29.0012 C 8.3368 28.4920 7.5823 28.5109 7.0919 29.0012 L 4.7342 31.3401 L 2.3765 29.0012 C 1.8673 28.4920 1.1317 28.4920 .6413 29.0012 C .1509 29.4917 .1509 30.2461 .6413 30.7177 L 2.9990 33.0754 L .6413 35.4142 C .1509 35.9235 .1509 36.6591 .6413 37.1495 Z M 23.6335 36.5459 C 23.8787 36.6591 24.1051 36.7156 24.3314 36.7156 C 25.1047 36.7156 25.6517 36.1121 25.6517 35.4708 C 25.6517 34.9992 25.4254 34.5466 24.8784 34.2825 C 24.6143 34.1505 24.3503 34.0184 24.0674 33.8675 C 25.4254 32.9056 26.9343 32.0568 28.5564 31.4155 C 28.3300 35.0558 27.6322 38.4132 26.5571 41.1670 L 17.5790 41.1670 C 18.5597 39.3185 20.0309 37.3758 21.8982 35.6594 C 22.4641 35.9800 23.0488 36.2630 23.6335 36.5459 Z M 16.2586 45.6560 C 16.2586 44.9959 16.3718 44.2603 16.6170 43.4869 L 25.4820 43.4869 C 23.7844 46.6180 21.5022 48.5418 18.8993 48.5418 C 17.0886 48.5418 16.2586 47.3536 16.2586 45.6560 Z"></path>
                            </g>
                          </svg>
                        </span>
                      </Tooltip>
                    </>
                  )}
                </div>
              </div>
            ))}
        </div>

        <p className="note-wrapper">
          Note: After copying the link and completing the signing
          process, please download the signed document and upload it
          in Power of Attorney.
        </p>
      </Modal>

      <Modal
        opened={isWesignModalOpen}
        onClose={() => { setShowContinueBtn(false); setIsWesignModalOpen(false); }}

        withCloseButton={false}
        fullScreen={true}
        padding={0}



      >



        <div style={{ height: "60px", background: "#fff", display: "flex", justifyContent: "flex-end", paddingRight: "20px", alignItems: "center" }}>

          <Close width={'40px'} height={'40px'} onClick={() => {
            setShowContinueBtn(false)
            setIsWesignModalOpen(false)
          }} />

        </div>
        {
          showContinueBtn && <div className="d-flex justify-content-end signature-modal-btn" >

            <button
              onClick={() => {
                handleClose();
                setShowContinueBtn(false)
              }}
              className="signature-btn"

            >
              Please press to continue
            </button>
          </div>
        }
        {wesignUrl ? (
          <iframe
            src={wesignUrl}
            title="Wesign"
            width="100%"
            height="90%"
            onLoad={handleLoad}
            style={{ border: "none" }}
          ></iframe>
        ) : (
          <p>Loading...</p>
        )}

      </Modal>

      <form
        onSubmit={handleSubmit(handleFormSubmit)}
        className="attorney-notes"
        id="attorney-notes-form"
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "35px" }}>
          <div className="file-a-claim">
            <Controller
              name="note"
              control={control}
              render={({ field }) => (
                <textarea
                  {...field}
                  onChange={(e) => {
                    field.onChange(e.target.value)
                    setDraftNote(e.target.value)
                  }}
                  rows={10}
                  className="textarea-wrapper"
                  placeholder="Please provide additional case details if needed"
                />
              )}
            />
            <div>
              <div
                className="d-flex flex-column justify-content-start "
                style={{ marginTop: "15px", gap: "10px" }}
              >
                <div className="attorney-notes-checkbox-input-container">
                  <input
                    type="checkbox"
                    className="form-check-input attorney-notes-checkbox-input"
                    id="termsCheckbox"
                    checked={isTermsChecked}
                    onChange={handleTermsChange}
                  />
                  <label
                    className="form-check-label mt-2"
                    htmlFor="termsCheckbox"
                    style={{ marginLeft: "12px" }}
                  >
                    I agree to the{" "}
                    <a
                      href="https://api.linsoatours.com/Images/other_document/FLT_Airline_claims_-_TC_1.pdf"
                      target="_blank"
                      onClick={handleTermsLinkClick}
                    >
                      Terms and Conditions
                    </a>
                  </label>
                </div>
                <div className="attorney-notes-checkbox-input-container mobile-attorney">
                  <input
                    type="checkbox"
                    className="form-check-input  attorney-notes-checkbox-input"
                    id="agreementCheckbox"
                    checked={isAgreementChecked}
                    onChange={(e) => {
                      if (handleCheckAgreement()) {
                        handleAgreementChange(e);
                      }
                    }}
                  />
                  <label
                    className="form-check-label mt-2"
                    htmlFor="agreementCheckbox"
                    style={{ marginLeft: "12px" }}
                  >
                    I agree to the{" "}
                    <Link
                      onClick={() => {
                        if (handleCheckAgreement()) {
                          setShowContinueBtn(false)
                          openAgreementModal();
                        }
                      }}
                    >
                      Agreement
                    </Link>
                  </label>
                  {signatureCaptured && (
                    <button
                      type="button"
                      onClick={() => {
                        if (pdfBlob) {
                          const url = URL.createObjectURL(pdfBlob);
                          window.open(url, "_blank");
                        }
                      }}
                      className="view-btn"
                    >
                      <span>
                        <svg
                          width="18px"
                          height="18px"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g
                            id="SVGRepo_tracerCarrier"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></g>
                          <g id="SVGRepo_iconCarrier">
                            {" "}
                            <path
                              d="M3.27489 15.2957C2.42496 14.1915 2 13.6394 2 12C2 10.3606 2.42496 9.80853 3.27489 8.70433C4.97196 6.49956 7.81811 4 12 4C16.1819 4 19.028 6.49956 20.7251 8.70433C21.575 9.80853 22 10.3606 22 12C22 13.6394 21.575 14.1915 20.7251 15.2957C19.028 17.5004 16.1819 20 12 20C7.81811 20 4.97196 17.5004 3.27489 15.2957Z"
                              stroke="#fff"
                              stroke-width="1.5"
                            ></path>{" "}
                            <path
                              d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
                              stroke="#fff"
                              stroke-width="1.5"
                            ></path>{" "}
                          </g>
                        </svg>
                      </span>
                      View Agreement
                    </button>
                  )}
                </div>
                {familyMembers.length > 0 && (
                  <div className="attorney-notes-checkbox-input-container mobile-attorney" style={{ flexWrap: "wrap", gap: "12px" }}>
                    <input
                      type="checkbox"
                      className="form-check-input attorney-notes-checkbox-input"
                      id="powerOfAttorneyCheckbox"
                      checked={isPowerOfAttorneyChecked}
                      onChange={(e) => {
                        if (handleCheckPowerOfAttorney()) {
                          handlePowerOfAttorneyChange(e);
                        }
                      }}
                    />
                    <label
                      className="form-check-label mt-2"
                      htmlFor="powerOfAttorneyCheckbox"
                    // style={{ marginLeft: "12px" }}
                    >
                      I agree to the{" "}
                      <Link
                        onClick={() => {
                          if (handleCheckPowerOfAttorney()) {
                            openPowerOfAttorneyModal();
                          }
                        }}
                      >
                        Power of Attorney
                      </Link>
                    </label>
                    {poaPdf !== null && (
                      <button
                        type="button"
                        onClick={() => {
                          if (poaPdf) {
                            const url = URL.createObjectURL(poaPdf);
                            window.open(url, "_blank");
                          }
                        }}
                        className="view-btn"
                      >
                        <span>
                          <svg
                            width="18px"
                            height="18px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <path
                                d="M3.27489 15.2957C2.42496 14.1915 2 13.6394 2 12C2 10.3606 2.42496 9.80853 3.27489 8.70433C4.97196 6.49956 7.81811 4 12 4C16.1819 4 19.028 6.49956 20.7251 8.70433C21.575 9.80853 22 10.3606 22 12C22 13.6394 21.575 14.1915 20.7251 15.2957C19.028 17.5004 16.1819 20 12 20C7.81811 20 4.97196 17.5004 3.27489 15.2957Z"
                                stroke="#fff"
                                stroke-width="1.5"
                              ></path>{" "}
                              <path
                                d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
                                stroke="#fff"
                                stroke-width="1.5"
                              ></path>{" "}
                            </g>
                          </svg>
                        </span>
                        View POA
                      </button>
                    )}


                    {signers &&
                      signers.length > 0 &&
                      signers.map((signer, index) => (
                        <div className="signer-box" key={index} style={{ width: "fit-content", gap: "15px", borderColor: "#e4e4e4" }}>
                          <div className="signer-details">
                            <span className="signer-icon">
                              {signer?.name.slice(0, 1).toUpperCase()}
                            </span>
                            <span className="signer-name">
                              {getSignerName(signer?.name)}
                            </span>
                          </div>

                          <div className="signer-status">
                            {signer?.signed ? (
                              <span className="signed-success">Signed</span>
                            ) : (
                              <>

                                <Tooltip label='Copy Link'>

                                  <span
                                    className="sign-btn"
                                    onClick={() => handleCopyLink(signer)}
                                  >
                                    <svg
                                      width="20px"
                                      height="20px"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g
                                        id="SVGRepo_bgCarrier"
                                        stroke-width="0"
                                      ></g>
                                      <g
                                        id="SVGRepo_tracerCarrier"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      ></g>
                                      <g id="SVGRepo_iconCarrier">
                                        {" "}
                                        <path
                                          d="M3 16V4C3 2.89543 3.89543 2 5 2H15M9 22H18C19.1046 22 20 21.1046 20 20V8C20 6.89543 19.1046 6 18 6H9C7.89543 6 7 6.89543 7 8V20C7 21.1046 7.89543 22 9 22Z"
                                          stroke="#314064"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        ></path>{" "}
                                      </g>
                                    </svg>
                                  </span>
                                </Tooltip>
                                <Tooltip label='Sign'>


                                  <span
                                    className="sign-btn"
                                    onClick={() => handleSignerClick(signer)}
                                  >
                                    <svg
                                      fill="#314064"
                                      width="20px"
                                      height="20px"
                                      viewBox="0 0 56 56"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g
                                        id="SVGRepo_bgCarrier"
                                        stroke-width="0"
                                      ></g>
                                      <g
                                        id="SVGRepo_tracerCarrier"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      ></g>
                                      <g id="SVGRepo_iconCarrier">
                                        <path d="M 1.1883 43.4869 L 13.6935 43.4869 C 13.4483 44.4300 13.3162 45.3542 13.3162 46.2030 C 13.3162 49.2397 15.0138 51.4088 18.5786 51.4088 C 22.9168 51.4088 26.4250 48.3532 28.6884 43.4869 L 54.8118 43.4869 C 55.4719 43.4869 56 42.9777 56 42.3175 C 56 41.6574 55.4719 41.1670 54.8118 41.1670 L 29.6315 41.1670 C 30.6877 38.0737 31.3290 34.4523 31.4611 30.5290 C 32.6494 30.2650 33.8941 30.1329 35.1769 30.1329 C 35.8371 30.1329 36.2141 30.4159 36.2141 30.9063 C 36.2141 32.5472 35.3276 33.8298 35.3276 35.4708 C 35.3276 36.9043 36.3841 37.7719 37.7608 37.7719 C 41.5896 37.7719 46.2108 31.2269 47.7385 31.2269 C 49.1342 31.2269 47.3990 37.1117 52.1522 37.1117 C 52.9256 37.1117 53.9253 36.9043 54.6986 36.4139 C 55.1513 36.0932 55.4719 35.6405 55.4719 35.0558 C 55.4719 34.3391 55.0192 33.7544 54.2648 33.7544 C 53.6046 33.7544 53.0577 34.3013 52.4164 34.3013 C 50.3792 34.3013 52.3218 28.0393 48.5687 28.0393 C 45.2868 28.0393 40.1561 34.4145 38.8548 34.4145 C 38.6852 34.4145 38.5531 34.3202 38.5531 34.0939 C 38.5531 33.4149 39.4017 31.8871 39.4017 30.3593 C 39.4017 28.4732 37.8361 27.2660 35.3844 27.2660 C 34.0451 27.2660 32.7248 27.3980 31.4611 27.6432 C 31.0461 17.7032 26.3307 9.8756 19.1256 9.8756 C 14.2782 9.8756 10.5436 14.0063 10.5436 19.2687 C 10.5436 25.4176 14.5423 30.6799 19.5217 34.1693 C 17.3149 36.3384 15.5985 38.8093 14.5423 41.1670 L 1.1883 41.1670 C .5281 41.1670 0 41.6574 0 42.3175 C 0 42.9777 .5281 43.4869 1.1883 43.4869 Z M 13.4106 19.2687 C 13.4106 15.5907 15.9003 12.7426 19.1256 12.7426 C 24.7841 12.7426 28.4432 19.7780 28.6130 28.4166 C 26.0101 29.3219 23.6335 30.6988 21.5776 32.3397 C 17.6544 29.6237 13.4106 25.1347 13.4106 19.2687 Z M .6413 37.1495 C 1.1317 37.6399 1.8673 37.6210 2.3765 37.1495 L 4.7342 34.7918 L 7.0919 37.1495 C 7.5823 37.6399 8.3368 37.6399 8.8272 37.1495 C 9.3176 36.6591 9.3176 35.9046 8.8272 35.4142 L 6.4695 33.0754 L 8.8272 30.7177 C 9.3176 30.2273 9.3176 29.4917 8.8272 29.0012 C 8.3368 28.4920 7.5823 28.5109 7.0919 29.0012 L 4.7342 31.3401 L 2.3765 29.0012 C 1.8673 28.4920 1.1317 28.4920 .6413 29.0012 C .1509 29.4917 .1509 30.2461 .6413 30.7177 L 2.9990 33.0754 L .6413 35.4142 C .1509 35.9235 .1509 36.6591 .6413 37.1495 Z M 23.6335 36.5459 C 23.8787 36.6591 24.1051 36.7156 24.3314 36.7156 C 25.1047 36.7156 25.6517 36.1121 25.6517 35.4708 C 25.6517 34.9992 25.4254 34.5466 24.8784 34.2825 C 24.6143 34.1505 24.3503 34.0184 24.0674 33.8675 C 25.4254 32.9056 26.9343 32.0568 28.5564 31.4155 C 28.3300 35.0558 27.6322 38.4132 26.5571 41.1670 L 17.5790 41.1670 C 18.5597 39.3185 20.0309 37.3758 21.8982 35.6594 C 22.4641 35.9800 23.0488 36.2630 23.6335 36.5459 Z M 16.2586 45.6560 C 16.2586 44.9959 16.3718 44.2603 16.6170 43.4869 L 25.4820 43.4869 C 23.7844 46.6180 21.5022 48.5418 18.8993 48.5418 C 17.0886 48.5418 16.2586 47.3536 16.2586 45.6560 Z"></path>
                                      </g>
                                    </svg>
                                  </span>
                                </Tooltip>
                              </>
                            )}
                          </div>
                        </div>
                      ))}

                  </div>


                )}


                {/* {
                  signers && signers.length > 0 && (<div className="attroney-signers">
                 
                    <h4>Signers</h4>
                    <div style={{display:"flex",gap:"10px",flexWrap:"wrap"}}>
                                   {signers &&
                                     signers.length > 0 &&
                                     signers.map((signer, index) => (
                                       <div className="signer-box" key={index} style={{width:"fit-content",gap:"15px",borderColor:"#e4e4e4"}}>
                                         <div className="signer-details">
                                           <span className="signer-icon">
                                             {signer?.name.slice(0, 1).toUpperCase()}
                                           </span>
                                           <span className="signer-name">
                                             {getSignerName(signer?.name)}
                                           </span>
                                         </div>
             
                                         <div className="signer-status">
                                           {signer?.signed ? (
                                             <span className="signed-success">Signed</span>
                                           ) : (
                                               <>
                                                
                                          <Tooltip label='Copy Link'>
                                                 
                                               <span
                                                 className="sign-btn"
                                                 onClick={() => handleCopyLink(signer)}
                                               >
                                                 <svg
                                                   width="20px"
                                                   height="20px"
                                                   viewBox="0 0 24 24"
                                                   fill="none"
                                                   xmlns="http://www.w3.org/2000/svg"
                                                 >
                                                   <g
                                                     id="SVGRepo_bgCarrier"
                                                     stroke-width="0"
                                                   ></g>
                                                   <g
                                                     id="SVGRepo_tracerCarrier"
                                                     stroke-linecap="round"
                                                     stroke-linejoin="round"
                                                   ></g>
                                                   <g id="SVGRepo_iconCarrier">
                                                     {" "}
                                                     <path
                                                       d="M3 16V4C3 2.89543 3.89543 2 5 2H15M9 22H18C19.1046 22 20 21.1046 20 20V8C20 6.89543 19.1046 6 18 6H9C7.89543 6 7 6.89543 7 8V20C7 21.1046 7.89543 22 9 22Z"
                                                       stroke="#314064"
                                                       stroke-width="2"
                                                       stroke-linecap="round"
                                                       stroke-linejoin="round"
                                                     ></path>{" "}
                                                   </g>
                                                 </svg>
                                                   </span>
                                                   </Tooltip>
                                          <Tooltip label='Sign'>
                                                   
             
                                               <span
                                                 className="sign-btn"
                                                 onClick={() => handleSignerClick(signer)}
                                               >
                                                 <svg
                                                   fill="#314064"
                                                   width="20px"
                                                   height="20px"
                                                   viewBox="0 0 56 56"
                                                   xmlns="http://www.w3.org/2000/svg"
                                                 >
                                                   <g
                                                     id="SVGRepo_bgCarrier"
                                                     stroke-width="0"
                                                   ></g>
                                                   <g
                                                     id="SVGRepo_tracerCarrier"
                                                     stroke-linecap="round"
                                                     stroke-linejoin="round"
                                                   ></g>
                                                   <g id="SVGRepo_iconCarrier">
                                                     <path d="M 1.1883 43.4869 L 13.6935 43.4869 C 13.4483 44.4300 13.3162 45.3542 13.3162 46.2030 C 13.3162 49.2397 15.0138 51.4088 18.5786 51.4088 C 22.9168 51.4088 26.4250 48.3532 28.6884 43.4869 L 54.8118 43.4869 C 55.4719 43.4869 56 42.9777 56 42.3175 C 56 41.6574 55.4719 41.1670 54.8118 41.1670 L 29.6315 41.1670 C 30.6877 38.0737 31.3290 34.4523 31.4611 30.5290 C 32.6494 30.2650 33.8941 30.1329 35.1769 30.1329 C 35.8371 30.1329 36.2141 30.4159 36.2141 30.9063 C 36.2141 32.5472 35.3276 33.8298 35.3276 35.4708 C 35.3276 36.9043 36.3841 37.7719 37.7608 37.7719 C 41.5896 37.7719 46.2108 31.2269 47.7385 31.2269 C 49.1342 31.2269 47.3990 37.1117 52.1522 37.1117 C 52.9256 37.1117 53.9253 36.9043 54.6986 36.4139 C 55.1513 36.0932 55.4719 35.6405 55.4719 35.0558 C 55.4719 34.3391 55.0192 33.7544 54.2648 33.7544 C 53.6046 33.7544 53.0577 34.3013 52.4164 34.3013 C 50.3792 34.3013 52.3218 28.0393 48.5687 28.0393 C 45.2868 28.0393 40.1561 34.4145 38.8548 34.4145 C 38.6852 34.4145 38.5531 34.3202 38.5531 34.0939 C 38.5531 33.4149 39.4017 31.8871 39.4017 30.3593 C 39.4017 28.4732 37.8361 27.2660 35.3844 27.2660 C 34.0451 27.2660 32.7248 27.3980 31.4611 27.6432 C 31.0461 17.7032 26.3307 9.8756 19.1256 9.8756 C 14.2782 9.8756 10.5436 14.0063 10.5436 19.2687 C 10.5436 25.4176 14.5423 30.6799 19.5217 34.1693 C 17.3149 36.3384 15.5985 38.8093 14.5423 41.1670 L 1.1883 41.1670 C .5281 41.1670 0 41.6574 0 42.3175 C 0 42.9777 .5281 43.4869 1.1883 43.4869 Z M 13.4106 19.2687 C 13.4106 15.5907 15.9003 12.7426 19.1256 12.7426 C 24.7841 12.7426 28.4432 19.7780 28.6130 28.4166 C 26.0101 29.3219 23.6335 30.6988 21.5776 32.3397 C 17.6544 29.6237 13.4106 25.1347 13.4106 19.2687 Z M .6413 37.1495 C 1.1317 37.6399 1.8673 37.6210 2.3765 37.1495 L 4.7342 34.7918 L 7.0919 37.1495 C 7.5823 37.6399 8.3368 37.6399 8.8272 37.1495 C 9.3176 36.6591 9.3176 35.9046 8.8272 35.4142 L 6.4695 33.0754 L 8.8272 30.7177 C 9.3176 30.2273 9.3176 29.4917 8.8272 29.0012 C 8.3368 28.4920 7.5823 28.5109 7.0919 29.0012 L 4.7342 31.3401 L 2.3765 29.0012 C 1.8673 28.4920 1.1317 28.4920 .6413 29.0012 C .1509 29.4917 .1509 30.2461 .6413 30.7177 L 2.9990 33.0754 L .6413 35.4142 C .1509 35.9235 .1509 36.6591 .6413 37.1495 Z M 23.6335 36.5459 C 23.8787 36.6591 24.1051 36.7156 24.3314 36.7156 C 25.1047 36.7156 25.6517 36.1121 25.6517 35.4708 C 25.6517 34.9992 25.4254 34.5466 24.8784 34.2825 C 24.6143 34.1505 24.3503 34.0184 24.0674 33.8675 C 25.4254 32.9056 26.9343 32.0568 28.5564 31.4155 C 28.3300 35.0558 27.6322 38.4132 26.5571 41.1670 L 17.5790 41.1670 C 18.5597 39.3185 20.0309 37.3758 21.8982 35.6594 C 22.4641 35.9800 23.0488 36.2630 23.6335 36.5459 Z M 16.2586 45.6560 C 16.2586 44.9959 16.3718 44.2603 16.6170 43.4869 L 25.4820 43.4869 C 23.7844 46.6180 21.5022 48.5418 18.8993 48.5418 C 17.0886 48.5418 16.2586 47.3536 16.2586 45.6560 Z"></path>
                                                   </g>
                                                 </svg>
                                               </span>
                                                   </Tooltip>
                                             </>
                                           )}
                                         </div>
                                       </div>
                                     ))}
                                 </div>
                    
                     </div>
                  )
                } */}

                {/* {
                  familyMembers.length > 0 && <p className="note-wrapper">
                    Please print and have all signatures completed. Email back document to <a href="mailto:claims@flyandclaim.com">claims@flyandclaim.com
                    </a> or access your claim from our website to sign the documents electronically.
                  </p>
                } */}
              </div>
              <AgreementModal
                isOpen={isAgreementModalOpen}
                onRequestClose={closeAgreementModal}
                onSignatureAdded={handleSignatureAdded}
                onPdfGenerated={handlePdfGenerated}
                setEnvelopeId={setEnvelopeId}
                setAgreementUrl={setAgreementUrl}
                envolpeId={envolpeId}
                signUrl={signUrl}
                setSignUrl={setSignUrl}
                setIsDocusignModalOpen={setIsDocusignModalOpen}
                setIsFetching={setIsFetching}
                setDocumentFetched={setDocumentFetched}
                agreementDetails={dataToStore}
                activeTab={activeTab}
              />






              {/* <PowerModal
                isOpen={isPowerModalOpen}
                onRequestClose={closePowerModal}
                agreementDetails={dataToStore}
                activeTab={activeTab}
              /> */}
              <DocuSignModal
                isOpen={isDocuSignModalOpen}
                onRequestClose={() => { setIsDocusignModalOpen(false); }}
                signUrl={signUrl}
                setSignUrl={setSignUrl}
                handleIframeClose={handleIframeClose}
              />

              <ViewFileModal
                isOpen={imageModalOpen}
                closeModal={closeImageModal}
                modalTitle={imageModalTitle}
                modalFileUrl={imageModalFileUrl}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Attorneynotes;
